import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

const Modal = (props) => {
  const closePopup = () => {
    props.hide(false);
  };


  //Return the popup for approve request
  return props.isShowing ? (
    <div>
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal approval" style={{ width: "150%" }}>
            <div className="modal-head-cross rate-modal">
              <button type="button" className="modal-close-button" onClick={closePopup}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="editNonFct-header modal-header">
                <h4 className="popup-head rqst-head fct-head modal-title">Performance Tracker</h4>
              </div>
              <div className="approval-content modal-body">
                <div className="popup-container reqst-rejection">
                <table className="table table-striped searchTable">
                  <tr>
                    <th> Performance Grade</th>
                    <th style={{textAlign:"center"}}>Silver</th>
                    <th style={{textAlign:"center"}}>Gold</th>
                  </tr>
                  <tr>
                    <th>Previous month order target</th>
                    <td style={{textAlign:"center"}}>{props.silver.targetCamp && props.silver.targetCamp}</td>
                    <td style={{textAlign:"center"}}>{props.gold.targetCamp && props.gold.targetCamp}</td>
                  </tr>
                  <tr style={{background:"#f2f2f2"}}>
                      <th>Previous month order actual</th>
                      <td colSpan={2} style={{textAlign:"center"}}>{props.totalCamp && props.totalCamp}</td>
                  </tr>
                  <tr>
                      <th>Previous month value target</th>
                      <td style={{textAlign:"center"}}>{props.silver.targetAmount && props.silver.targetAmount}</td>
                    <td style={{textAlign:"center"}}>{props.gold.targetAmount && props.gold.targetAmount}</td>
                  </tr>
                  <tr style={{background:"#f2f2f2"}}>
                      <th>Previous month value actual</th>
                      <td colSpan={2} style={{textAlign:"center"}}>{props.targetAmountAcheieved && props.targetAmountAcheieved}</td>
                  </tr>
              </table>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default Modal;



// WEBPACK FOOTER //
// ./web/components/salesUser/common/performancetracker.js